/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DigitalPlatformRawBody } from '../models/DigitalPlatformRawBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicServiceInspectionFromKotsaService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns DigitalPlatformRawBody OK
   * @throws ApiError
   */
  public updateReservation1({
    requestBody,
  }: {
    requestBody: DigitalPlatformRawBody,
  }): CancelablePromise<DigitalPlatformRawBody> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/api/I0000002/CarInscRsrvSrvc/updateMoisMngrRsrvInfo',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns DigitalPlatformRawBody OK
   * @throws ApiError
   */
  public receiveInspectionCompleted({
    requestBody,
  }: {
    requestBody: DigitalPlatformRawBody,
  }): CancelablePromise<DigitalPlatformRawBody> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/api/I0000002/CarInscRsrvSrvc/retrieveMoisInscPrgsYn',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * @returns DigitalPlatformRawBody OK
   * @throws ApiError
   */
  public cancelReservation({
    requestBody,
  }: {
    requestBody: DigitalPlatformRawBody,
  }): CancelablePromise<DigitalPlatformRawBody> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/public-service/api/I0000002/CarInscRsrvSrvc/deleteMoisMngrRsrvInfo',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
